import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana11Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1466_33062)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M686.874 555.074L698.808 596.843L657.039 631.153L640.63 569.992L686.874 555.074Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M628.7 647.56L657.043 631.151L642.126 574.465L601.849 586.399C604.335 601.316 610.501 632.941 615.274 640.102C620.048 647.262 626.214 648.058 628.7 647.56Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M671.96 501.371L686.877 555.074L640.633 569.991L624.224 514.797L671.96 501.371Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M583.944 526.732L601.845 586.402L642.122 574.468L624.222 514.798L583.944 526.732Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M567.541 467.058L583.95 526.728L624.227 514.794L609.309 455.124L567.541 467.058Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M657.042 447.669L671.96 501.372L624.224 514.798L610.798 461.095L657.042 447.669Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M642.124 393.965L657.042 447.668L610.797 461.093L595.88 407.391L642.124 393.965Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M551.128 407.391L567.538 467.061L609.307 455.127L592.897 395.457L551.128 407.391Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M627.209 340.263L642.126 393.966L595.882 407.391L580.965 353.688L627.209 340.263Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M610.797 280.592L627.206 340.262L580.962 353.688L570.52 320.869C577.979 310.427 594.09 288.051 598.863 282.084C603.637 276.117 608.808 278.603 610.797 280.592Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M539.195 361.147L551.129 407.391L592.898 395.457L570.522 320.87L539.195 361.147Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1466_33062" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1466_33062" transform="matrix(0.00204618 0 0 0.00271269 -4.91451 -0.656435)"/>
    </pattern>
    <image id="image0_1466_33062" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};